<template lang="pug">
div.breakdown
    div.breakdown-section(v-if="(parent === 'builder' && volumeTotal === 0) || (parent === 'monitoring' && selectedAudienceDesktopVolume === 0)")
        p.no-breakdown There is no user reached ...

    template(v-else)
        div.breakdown-content.container-loading.is-loading(v-if="isLoading")
            div.content
                div.stripe.medium-stripe.title
                div.stripe.small-stripe.category
                div.stripe.small-stripe.category
                div.stripe.small-stripe.category
            div.content
                div.stripe.medium-stripe.title
                div.stripe.small-stripe.category
                div.stripe.small-stripe.category
                div.stripe.small-stripe.category
            div.content
                div.stripe.medium-stripe.title
                div.stripe.small-stripe.category
                div.stripe.small-stripe.category
                div.stripe.small-stripe.category

        div.breakdown-content(v-else)
            //- if parent = builder
            template(v-if="parent === 'builder'")
                p.no-breakdown(v-if="topClusters.length == 0") No cluster available
                div.breakdown-section(v-else)
                    sectionHeader.breakdown-title(title="clusters")
                    div.cluster-list
                        div.cluster-item(v-for="data in topClusters")
                            span.breakdown-label {{ data.key }}
                            span.breakdown-value {{ round(data[sortClusterBy]) }}

            //- charts
            p.no-breakdown(v-if="!displayCharts") No breakdown available
            template(v-else)
                BreakdownChart(:selectedAudienceBreakdown="breakdownData" name="gender")
                BreakdownChart(:selectedAudienceBreakdown="breakdownData" name="age")
                BreakdownChart(:selectedAudienceBreakdown="breakdownData" name="income")
                BreakdownChart(:selectedAudienceBreakdown="breakdownData" name="education")
</template>

<script>
import { mapState } from 'vuex'

import { find, get, isEmpty, isNil, orderBy, take } from 'lodash'

import SectionHeader from '@/components/common/SectionHeader'
import BreakdownChart from '@/components/common/BreakdownChart'

export default {
    name: 'Breakdown',

    props: {
        breakdown: {
            type: [Object],
            default: undefined,
            required: false
        },
        loading: {
            type: [Boolean, Number],
            default: false
        },
        parent: {
            type: String,
            required: true
        },
        volumes: {
            type: [Object],
            default: undefined,
            required: false
        },

    },

    components: {
        BreakdownChart,
        SectionHeader
    },

    computed: {
        ...mapState('ui/monitoring', {
            audienceIsLoading: state => state.isLoading.breakdown,
            audienceSelectedId: state => state.selectedRowId
        }),

        ...mapState('data/audience', {
            audienceList: state => state.list
        }),

        selectedAudience() {
            return find(this.audienceList, audience => audience.id === this.audienceSelectedId)
        },

        selectedAudienceIsEmpty() {
            for (const criteria in this.selectedAudience.breakdown) {
                if (!isNil(this.selectedAudience[criteria])) {
                    return false
                }
            }
            return true
        },

        selectedAudienceBreakdown() {
            if (
                !isNil(this.selectedAudience) &&
                !isNil(this.selectedAudience.breakdown) &&
                (!this.selectedAudienceIsEmpty || this.parent === 'monitoring')
            ) {
                return this.selectedAudience.breakdown
            }
            return null
        },

        breakdownData() {
            return this.parent === 'builder' ? this.breakdown : this.selectedAudienceBreakdown
        },

        selectedAudienceDesktopVolume() {
            return !isNil(this.selectedAudience)
                ? !isNil(get(this.selectedAudience, 'volumes', null))
                    ? this.selectedAudience.volumes.total_desktop
                    : null
                : null
        },

        isLoading() {
            return (this.parent === 'builder' && this.loading) || (this.parent === 'monitoring' && this.audienceIsLoading)
        },

        displayCharts() {
            return (this.parent === 'builder' && !isEmpty(this.breakdown)) || (this.parent === 'monitoring' && !isNil(this.selectedAudienceBreakdown))
        },

        sortClusterBy() {
            //for now, sort cluster by default 'cluster_in_segment'
            return 'cluster_in_segment'
        },

        topClusters() {
            return this.getTopClusters({ topNumber: 5, sortItem: this.sortClusterBy })
        },

        volumeTotal() {
            return isNil(this.volumes) ? null : this.volumes.total_desktop
        }
    },

    methods: {
        getTopClusters({ topNumber, sortItem }) {
            const clusters = []
            const _clusters = this.breakdownData?.clusters ?? {}

            if (isEmpty(_clusters)) return []

            for (const key in _clusters) {
                const cluster = _clusters[key]
                if (!isEmpty(cluster)) clusters.push({ ...cluster, key })
            }

            //sort by sortItem descdending order, if same sortItem value, alphabetical order
            const sortedClusters = orderBy(clusters, [sortItem, 'key'], ['desc', 'asc'])

            //return top clusters
            return take(sortedClusters, topNumber)
        },

        round(data) {
            return Math.round(data * 100) / 100
        }
    }
}
</script>
